import { FC, useState } from 'react'
import { Alert, Button, Spinner, Typography } from '@material-tailwind/react'
import { colors } from '@material-tailwind/react/types/generic'
import { PiSpeakerX, PiSwap } from 'react-icons/pi'
import { useTranslation } from 'react-i18next'
import ReactPlayer from 'react-player'
import { useDarkMode } from '../contexts/DarkModeContext'

interface AgamiVideoFilePreviewProps {
  videoLabel?: string
  videoUrl?: string
  openFileDialog: () => void
  showMedia: boolean
}

const AgamiVideoFilePreview: FC<AgamiVideoFilePreviewProps> = ({
  videoLabel,
  videoUrl,
  openFileDialog,
  showMedia,
}) => {
  const { t } = useTranslation()
  const [videoReady, setVideoReady] = useState(false)
  const { darkMode } = useDarkMode()

  return (
    <div className="w-full flex flex-col gap-4 text-center justify-start items-start mt-4">
      <div className="flex flex-col md:flex-row justify-start md:justify-center items-start md:items-center gap-2">
        <Typography className="font-bold text-xl font-barlow">
          {videoLabel ?? t('videoFile.noLabel')}
        </Typography>
        <Button
          variant="outlined"
          color={darkMode ? 'white' : ('primary' as colors)} // eslint-disable-line @typescript-eslint/no-explicit-any
          size="sm"
          onClick={openFileDialog}
          className="flex justify-center items-center gap-1"
        >
          <PiSwap className="h-4 w-4" />
          {t('videoFile.replace')}
        </Button>
      </div>

      {videoUrl && showMedia && (
        <div
          className="relative w-full min-h-[100px] flex justify-center items-center mt-1 rounded-lg overflow-hidden"
          data-testid="agami-video-player"
        >
          {!videoReady && (
            <div className="absolute">
              <Spinner />
            </div>
          )}
          <ReactPlayer
            width="100%"
            height="100%"
            controls
            url={videoUrl}
            onReady={() => setVideoReady(true)}
          />
        </div>
      )}

      {!videoUrl && showMedia && (
        <div className="relative w-full min-h-[100px] flex justify-center items-center mt-1 rounded-lg overflow-hidden">
          <Alert
            color="orange"
            className="w-full md:w-1/2 py-2 px-4 mt-2 text-xs"
            icon={<PiSpeakerX className="w-4 h-4" />}
          >
            {t('videoFile.notFound')}
          </Alert>
        </div>
      )}
    </div>
  )
}

export default AgamiVideoFilePreview
